import React, { forwardRef } from 'react'
import { SvgIcon } from '@mui/material'

/**
 * The ErrorIcon's component.
 */
const ErrorIcon = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    height="16px"
    ref={ref}
    version="1.1"
    viewBox="0 0 16 16"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM5.1 13.3L3.5 12L11 2.6L12.5 3.8L5.1 13.3Z"
      stroke="none"
    />
  </SvgIcon>
))

export default ErrorIcon
